import BasicSensorSettingsModal from './BasicSensorSettingsModal/BasicSensorSettingsModal';

// const channelTypeToModalMap = {
//   [ChannelGroupType.TEMP_ANALOG.id]: SettingsWithAnalogModal,
//   [ChannelGroupType.TEMP_AIR_FLOW.id]: SettingsWithAirFlowModal,
// };

// eslint-disable-next-line max-len
// const sensorSettingsModalFactory = (channelType) => channelTypeToModalMap[channelType] || BasicSensorSettingsModal;
// todo : for now just using one settings modal for everything,
//  in future we may need to handle different sensor type settings
const sensorSettingsModalFactory = () => BasicSensorSettingsModal;

export default sensorSettingsModalFactory;
